import { Record, Union } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { unit_type, lambda_type, class_type, tuple_type, list_type, float64_type, bool_type, option_type, record_type, int32_type, string_type, union_type } from "../fable_modules/fable-library-js.4.28.0/Reflection.js";
import { Dietary_vegetarianDesc, Dietary_noAlcoholDesc, Dietary_lowSodiumDesc, Dietary_diabeticDesc, Dietary_soyFreeDesc, Dietary_eggFreeDesc, Dietary_shellfishFreeDesc, Dietary_nutFreeDesc, Dietary_dairyFreeDesc, Dietary_lactoseFreeDesc, Dietary_glutenFreeDesc, Dietary_hinduVegDesc, Dietary_kosherDesc, Dietary_halalDesc, Dietary_noPorkDesc, Dietary_noRedMeatDesc, Dietary_pescatarianDesc, Dietary_veganDesc, Dietary_vegetarian, Dietary_noAlcohol, Dietary_lowSodium, Dietary_diabetic, Dietary_soyFree, Dietary_eggFree, Dietary_shellfishFree, Dietary_nutFree, Dietary_dairyFree, Dietary_lactoseFree, Dietary_glutenFree, Dietary_hinduVeg, Dietary_kosher, Dietary_halal, Dietary_noPork, Dietary_noRedMeat, Dietary_pescatarian, Dietary_vegan, Enum_Emptyseat_off, Enum_Emptyseat_consolidate, Enum_Emptyseat_spread, Enum_Emptyseat_reduce, Tag_groups_clusterDesc, Tag_groups_ignoreDesc, Tag_groups_pairDesc, Tag_groups_bridgeDesc, Tag_groups_spreadDesc, Tag_groups_cluster, Tag_groups_ignore, Tag_groups_pair, Tag_groups_bridge, Tag_groups_spread, Tag_groups_organizational, Tag_groups_custom2, Tag_groups_custom1, Tag_groups_education, Tag_groups_language, Tag_groups_lifeStage, Tag_groups_hobby, Weight_FillHonorTable, Weight_RankProximity, Weight_TagGroupSeating, Weight_ChildNearParent, Weight_WheelchairAccess, Weight_AcquaintanceSpread, Weight_AgeMixing, Weight_BalanceGender, Weight_BalanceTableSizes, Weight_HostAtHead, Weight_GuestOfHonor, Weight_SpreadFamilies, Weight_SeparateCouples, Weight_GenderAlternation } from "./Tr.js";
import { map as map_1, filter, singleton, append, exists, fold, empty, isEmpty, map2, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { ofList } from "../fable_modules/fable-library-js.4.28.0/Map.js";
import { compare } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { split, compare as compare_1, join } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { map } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.28.0/Result.js";

export class Gender extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Male", "Female", "NonBinary", "Unspecified"];
    }
}

export function Gender_$reflection() {
    return union_type("Shared.Gender", [], Gender, () => [[], [], [], []]);
}

export function GenderModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

export function GenderModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new Gender(0, []);
        case 1:
            return new Gender(1, []);
        case 2:
            return new Gender(2, []);
        case 3:
            return new Gender(3, []);
        default:
            return new Gender(3, []);
    }
}

export function GenderModule_fromString(s) {
    const matchValue = s.toUpperCase();
    switch (matchValue) {
        case "M":
        case "MALE":
            return new Gender(0, []);
        case "F":
        case "FEMALE":
            return new Gender(1, []);
        case "NB":
        case "NONBINARY":
        case "NON-BINARY":
            return new Gender(2, []);
        default:
            return new Gender(3, []);
    }
}

export class AgeCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Child", "Teen", "Adult", "Senior"];
    }
}

export function AgeCategory_$reflection() {
    return union_type("Shared.AgeCategory", [], AgeCategory, () => [[], [], [], []]);
}

export function AgeCategoryModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

export function AgeCategoryModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new AgeCategory(0, []);
        case 1:
            return new AgeCategory(1, []);
        case 2:
            return new AgeCategory(2, []);
        case 3:
            return new AgeCategory(3, []);
        default:
            return new AgeCategory(2, []);
    }
}

export class AttendanceStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "NotInvited", "Invited", "Attending", "NotAttending"];
    }
}

export function AttendanceStatus_$reflection() {
    return union_type("Shared.AttendanceStatus", [], AttendanceStatus, () => [[], [], [], [], []]);
}

export function AttendanceStatusModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function AttendanceStatusModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new AttendanceStatus(0, []);
        case 1:
            return new AttendanceStatus(1, []);
        case 2:
            return new AttendanceStatus(2, []);
        case 3:
            return new AttendanceStatus(3, []);
        case 4:
            return new AttendanceStatus(4, []);
        default:
            return new AttendanceStatus(0, []);
    }
}

export function AttendanceStatusModule_fromString(s) {
    const matchValue = s.toUpperCase();
    switch (matchValue) {
        case "ACTIVE":
            return new AttendanceStatus(0, []);
        case "NOTINVITED":
        case "NOT_INVITED":
        case "NOT INVITED":
            return new AttendanceStatus(1, []);
        case "INVITED":
            return new AttendanceStatus(2, []);
        case "ATTENDING":
            return new AttendanceStatus(3, []);
        case "NOTATTENDING":
        case "NOT_ATTENDING":
        case "NOT ATTENDING":
            return new AttendanceStatus(4, []);
        default:
            return new AttendanceStatus(0, []);
    }
}

export function AttendanceStatusModule_isSeated(_arg) {
    switch (_arg.tag) {
        case 1:
        case 4:
            return false;
        default:
            return true;
    }
}

export class RsvpStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RsvpNotSent", "RsvpPending", "RsvpAccepted", "RsvpDeclined", "RsvpMaybe"];
    }
}

export function RsvpStatus_$reflection() {
    return union_type("Shared.RsvpStatus", [], RsvpStatus, () => [[], [], [], [], []]);
}

export function RsvpStatusModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function RsvpStatusModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new RsvpStatus(0, []);
        case 1:
            return new RsvpStatus(1, []);
        case 2:
            return new RsvpStatus(2, []);
        case 3:
            return new RsvpStatus(3, []);
        case 4:
            return new RsvpStatus(4, []);
        default:
            return new RsvpStatus(0, []);
    }
}

export class PairType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Spouse", "Partner", "Engaged", "Dating"];
    }
}

export function PairType_$reflection() {
    return union_type("Shared.PairType", [], PairType, () => [[], [], [], []]);
}

export function PairTypeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

export function PairTypeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new PairType(0, []);
        case 1:
            return new PairType(1, []);
        case 2:
            return new PairType(2, []);
        case 3:
            return new PairType(3, []);
        default:
            return new PairType(1, []);
    }
}

export class TableShape extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Round", "Rectangular", "Oval", "Square"];
    }
}

export function TableShape_$reflection() {
    return union_type("Shared.TableShape", [], TableShape, () => [[], [], [], []]);
}

export function TableShapeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

export function TableShapeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new TableShape(0, []);
        case 1:
            return new TableShape(1, []);
        case 2:
            return new TableShape(2, []);
        case 3:
            return new TableShape(3, []);
        default:
            return new TableShape(0, []);
    }
}

export class SeatingStyle extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllSides", "OneSided"];
    }
}

export function SeatingStyle_$reflection() {
    return union_type("Shared.SeatingStyle", [], SeatingStyle, () => [[], []]);
}

export function SeatingStyleModule_toInt(_arg) {
    if (_arg.tag === 1) {
        return 1;
    }
    else {
        return 0;
    }
}

export function SeatingStyleModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new SeatingStyle(0, []);
        case 1:
            return new SeatingStyle(1, []);
        default:
            return new SeatingStyle(0, []);
    }
}

export class EventType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FormalDinner", "Wedding", "Banquet", "CorporateEvent", "Casual", "Custom"];
    }
}

export function EventType_$reflection() {
    return union_type("Shared.EventType", [], EventType, () => [[], [], [], [], [], []]);
}

export function EventTypeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        default:
            return 0;
    }
}

export function EventTypeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new EventType(0, []);
        case 1:
            return new EventType(1, []);
        case 2:
            return new EventType(2, []);
        case 3:
            return new EventType(3, []);
        case 4:
            return new EventType(4, []);
        case 5:
            return new EventType(5, []);
        default:
            return new EventType(5, []);
    }
}

export class CulturePreset extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["International", "Swedish", "French", "Chinese", "British", "American", "CustomCulture"];
    }
}

export function CulturePreset_$reflection() {
    return union_type("Shared.CulturePreset", [], CulturePreset, () => [[], [], [], [], [], [], []]);
}

export function CulturePresetModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        case 6:
            return 6;
        default:
            return 0;
    }
}

export function CulturePresetModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new CulturePreset(0, []);
        case 1:
            return new CulturePreset(1, []);
        case 2:
            return new CulturePreset(2, []);
        case 3:
            return new CulturePreset(3, []);
        case 4:
            return new CulturePreset(4, []);
        case 5:
            return new CulturePreset(5, []);
        case 6:
            return new CulturePreset(6, []);
        default:
            return new CulturePreset(0, []);
    }
}

export class ConstraintKey extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GenderAlternation", "SeparateCouples", "SpreadFamilies", "GuestOfHonor", "HostAtHead", "BalanceTableSizes", "BalanceGender", "AgeMixing", "AcquaintanceSpread", "WheelchairAccess", "ChildNearParent", "TagGroupSeating", "RankProximity", "FillHonorTable"];
    }
}

export function ConstraintKey_$reflection() {
    return union_type("Shared.ConstraintKey", [], ConstraintKey, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export const SoftConstraintWeights_allConstraints = ofArray([[new ConstraintKey(0, []), Weight_GenderAlternation], [new ConstraintKey(1, []), Weight_SeparateCouples], [new ConstraintKey(2, []), Weight_SpreadFamilies], [new ConstraintKey(3, []), Weight_GuestOfHonor], [new ConstraintKey(4, []), Weight_HostAtHead], [new ConstraintKey(5, []), Weight_BalanceTableSizes], [new ConstraintKey(6, []), Weight_BalanceGender], [new ConstraintKey(7, []), Weight_AgeMixing], [new ConstraintKey(8, []), Weight_AcquaintanceSpread], [new ConstraintKey(9, []), Weight_WheelchairAccess], [new ConstraintKey(10, []), Weight_ChildNearParent], [new ConstraintKey(11, []), Weight_TagGroupSeating], [new ConstraintKey(12, []), Weight_RankProximity], [new ConstraintKey(13, []), Weight_FillHonorTable]]);

export function SoftConstraintWeights_presetWeights(preset) {
    return ofList(map2((tupledArg, weight) => [tupledArg[0], weight], SoftConstraintWeights_allConstraints, (preset.tag === 1) ? ofArray([9, 8, 6, 9, 9, 5, 7, 4, 4, 8, 8, 3, 5, 10]) : ((preset.tag === 2) ? ofArray([9, 8, 5, 9, 8, 5, 7, 4, 4, 8, 8, 3, 7, 10]) : ((preset.tag === 3) ? ofArray([3, 2, 2, 9, 8, 5, 3, 3, 3, 8, 8, 3, 9, 10]) : ((preset.tag === 4) ? ofArray([8, 7, 5, 8, 9, 5, 6, 4, 4, 8, 8, 3, 6, 10]) : ((preset.tag === 5) ? ofArray([3, 2, 4, 5, 5, 5, 3, 5, 5, 8, 8, 3, 3, 8]) : ((preset.tag === 6) ? ofArray([5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5]) : ofArray([6, 4, 5, 7, 7, 5, 5, 4, 4, 8, 8, 3, 4, 9]))))))), {
        Compare: compare,
    });
}

export const SoftConstraintWeights_defaultWeights = SoftConstraintWeights_presetWeights(new CulturePreset(0, []));

export class TagGroup extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Organizational", "Hobby", "LifeStage", "LanguageGroup", "Education", "CustomGroup1", "CustomGroup2"];
    }
}

export function TagGroup_$reflection() {
    return union_type("Shared.TagGroup", [], TagGroup, () => [[], [], [], [], [], [], []]);
}

export function TagGroupModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        case 6:
            return 6;
        default:
            return 0;
    }
}

export function TagGroupModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new TagGroup(0, []);
        case 1:
            return new TagGroup(1, []);
        case 2:
            return new TagGroup(2, []);
        case 3:
            return new TagGroup(3, []);
        case 4:
            return new TagGroup(4, []);
        case 5:
            return new TagGroup(5, []);
        case 6:
            return new TagGroup(6, []);
        default:
            return new TagGroup(5, []);
    }
}

export function TagGroupModule_label(_arg) {
    switch (_arg.tag) {
        case 1:
            return Tag_groups_hobby;
        case 2:
            return Tag_groups_lifeStage;
        case 3:
            return Tag_groups_language;
        case 4:
            return Tag_groups_education;
        case 5:
            return Tag_groups_custom1;
        case 6:
            return Tag_groups_custom2;
        default:
            return Tag_groups_organizational;
    }
}

export const TagGroupModule_allGroups = ofArray([new TagGroup(0, []), new TagGroup(1, []), new TagGroup(2, []), new TagGroup(3, []), new TagGroup(4, []), new TagGroup(5, []), new TagGroup(6, [])]);

export class TagGroupStrategy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Cluster", "Spread", "Bridge", "Pair", "Ignore"];
    }
}

export function TagGroupStrategy_$reflection() {
    return union_type("Shared.TagGroupStrategy", [], TagGroupStrategy, () => [[], [], [], [], []]);
}

export function TagGroupStrategyModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function TagGroupStrategyModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new TagGroupStrategy(0, []);
        case 1:
            return new TagGroupStrategy(1, []);
        case 2:
            return new TagGroupStrategy(2, []);
        case 3:
            return new TagGroupStrategy(3, []);
        case 4:
            return new TagGroupStrategy(4, []);
        default:
            return new TagGroupStrategy(4, []);
    }
}

export function TagGroupStrategyModule_label(_arg) {
    switch (_arg.tag) {
        case 1:
            return Tag_groups_spread;
        case 2:
            return Tag_groups_bridge;
        case 3:
            return Tag_groups_pair;
        case 4:
            return Tag_groups_ignore;
        default:
            return Tag_groups_cluster;
    }
}

export function TagGroupStrategyModule_description(_arg) {
    switch (_arg.tag) {
        case 1:
            return (v_2) => ((v_3) => Tag_groups_spreadDesc(v_2, v_3));
        case 2:
            return (v_4) => ((v_5) => Tag_groups_bridgeDesc(v_4, v_5));
        case 3:
            return (v_6) => ((v_7) => Tag_groups_pairDesc(v_6, v_7));
        case 4:
            return (v_8) => ((v_9) => Tag_groups_ignoreDesc(v_8, v_9));
        default:
            return (v) => ((v_1) => Tag_groups_clusterDesc(v, v_1));
    }
}

export class SolverBackend extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FsFacileSolver", "OrToolsSolver"];
    }
}

export function SolverBackend_$reflection() {
    return union_type("Shared.SolverBackend", [], SolverBackend, () => [[], []]);
}

export function SolverBackendModule_toInt(_arg) {
    if (_arg.tag === 1) {
        return 1;
    }
    else {
        return 0;
    }
}

export function SolverBackendModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new SolverBackend(0, []);
        case 1:
            return new SolverBackend(1, []);
        default:
            return new SolverBackend(0, []);
    }
}

export class ToastLevel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ToastSuccess", "ToastError", "ToastWarning", "ToastInfo"];
    }
}

export function ToastLevel_$reflection() {
    return union_type("Shared.ToastLevel", [], ToastLevel, () => [[], [], [], []]);
}

export class EmptySeatStrategy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AllTables", "ReduceTables", "SpreadEmpties", "ConsolidateEmpties"];
    }
}

export function EmptySeatStrategy_$reflection() {
    return union_type("Shared.EmptySeatStrategy", [], EmptySeatStrategy, () => [[], [], [], []]);
}

export function EmptySeatStrategyModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

export function EmptySeatStrategyModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new EmptySeatStrategy(0, []);
        case 1:
            return new EmptySeatStrategy(1, []);
        case 2:
            return new EmptySeatStrategy(2, []);
        case 3:
            return new EmptySeatStrategy(3, []);
        default:
            return new EmptySeatStrategy(0, []);
    }
}

export function EmptySeatStrategyModule_label(_arg) {
    switch (_arg.tag) {
        case 1:
            return Enum_Emptyseat_reduce;
        case 2:
            return Enum_Emptyseat_spread;
        case 3:
            return Enum_Emptyseat_consolidate;
        default:
            return Enum_Emptyseat_off;
    }
}

export class ExportTheme extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ClassicWarmth", "RomanticBlush", "CorporateNavy", "GardenBotanical", "MidnightFestive"];
    }
}

export function ExportTheme_$reflection() {
    return union_type("Shared.ExportTheme", [], ExportTheme, () => [[], [], [], [], []]);
}

export function ExportThemeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function ExportThemeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new ExportTheme(0, []);
        case 1:
            return new ExportTheme(1, []);
        case 2:
            return new ExportTheme(2, []);
        case 3:
            return new ExportTheme(3, []);
        case 4:
            return new ExportTheme(4, []);
        default:
            return new ExportTheme(0, []);
    }
}

export class ExportLayout extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ElegantSerif", "CleanModern", "Handwritten", "BoldStatement", "VintageClassic"];
    }
}

export function ExportLayout_$reflection() {
    return union_type("Shared.ExportLayout", [], ExportLayout, () => [[], [], [], [], []]);
}

export function ExportLayoutModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function ExportLayoutModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new ExportLayout(0, []);
        case 1:
            return new ExportLayout(1, []);
        case 2:
            return new ExportLayout(2, []);
        case 3:
            return new ExportLayout(3, []);
        case 4:
            return new ExportLayout(4, []);
        default:
            return new ExportLayout(0, []);
    }
}

export class UserRole extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Owner", "Editor", "Viewer"];
    }
}

export function UserRole_$reflection() {
    return union_type("Shared.UserRole", [], UserRole, () => [[], [], []]);
}

export function UserRoleModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function UserRoleModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new UserRole(0, []);
        case 1:
            return new UserRole(1, []);
        case 2:
            return new UserRole(2, []);
        default:
            return new UserRole(2, []);
    }
}

export function UserRoleModule_isAtLeast(required, actual) {
    return UserRoleModule_toInt(actual) <= UserRoleModule_toInt(required);
}

export class RuleType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["KeepApart", "KeepTogether", "Adjacent", "Opposite", "AssignTable", "AssignSeat", "ExcludeFromTable", "MaxPerTable", "MinPerTable"];
    }
}

export function RuleType_$reflection() {
    return union_type("Shared.RuleType", [], RuleType, () => [[], [], [], [], [], [], [], [], []]);
}

export function RuleTypeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        case 6:
            return 6;
        case 7:
            return 7;
        case 8:
            return 8;
        default:
            return 0;
    }
}

export function RuleTypeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new RuleType(0, []);
        case 1:
            return new RuleType(1, []);
        case 2:
            return new RuleType(2, []);
        case 3:
            return new RuleType(3, []);
        case 4:
            return new RuleType(4, []);
        case 5:
            return new RuleType(5, []);
        case 6:
            return new RuleType(6, []);
        case 7:
            return new RuleType(7, []);
        case 8:
            return new RuleType(8, []);
        default:
            return new RuleType(0, []);
    }
}

export class PublicLinkType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FindYourSeat", "FloorPlan", "SeatingChart", "PublicRsvp"];
    }
}

export function PublicLinkType_$reflection() {
    return union_type("Shared.PublicLinkType", [], PublicLinkType, () => [[], [], [], []]);
}

export function PublicLinkTypeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function PublicLinkTypeModule_fromInt(_arg) {
    switch (_arg) {
        case 1:
            return new PublicLinkType(0, []);
        case 2:
            return new PublicLinkType(1, []);
        case 3:
            return new PublicLinkType(2, []);
        case 4:
            return new PublicLinkType(3, []);
        default:
            return new PublicLinkType(0, []);
    }
}

export class PublicLinkSecurityMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NameLookup", "NameAndKeyword", "PinProtected", "OpenView"];
    }
}

export function PublicLinkSecurityMode_$reflection() {
    return union_type("Shared.PublicLinkSecurityMode", [], PublicLinkSecurityMode, () => [[], [], [], []]);
}

export function PublicLinkSecurityModeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function PublicLinkSecurityModeModule_fromInt(_arg) {
    switch (_arg) {
        case 1:
            return new PublicLinkSecurityMode(0, []);
        case 2:
            return new PublicLinkSecurityMode(1, []);
        case 3:
            return new PublicLinkSecurityMode(2, []);
        case 4:
            return new PublicLinkSecurityMode(3, []);
        default:
            return new PublicLinkSecurityMode(0, []);
    }
}

export class PublicLinkDisplayMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TableOnly", "TableAndDiagram", "TableAndNeighbors", "FullChart"];
    }
}

export function PublicLinkDisplayMode_$reflection() {
    return union_type("Shared.PublicLinkDisplayMode", [], PublicLinkDisplayMode, () => [[], [], [], []]);
}

export function PublicLinkDisplayModeModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function PublicLinkDisplayModeModule_fromInt(_arg) {
    switch (_arg) {
        case 1:
            return new PublicLinkDisplayMode(0, []);
        case 2:
            return new PublicLinkDisplayMode(1, []);
        case 3:
            return new PublicLinkDisplayMode(2, []);
        case 4:
            return new PublicLinkDisplayMode(3, []);
        default:
            return new PublicLinkDisplayMode(0, []);
    }
}

export class User extends Record {
    constructor(Id, Email, Name, Role, CreatedAt) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Name = Name;
        this.Role = (Role | 0);
        this.CreatedAt = CreatedAt;
    }
}

export function User_$reflection() {
    return record_type("Shared.User", [], User, () => [["Id", string_type], ["Email", string_type], ["Name", string_type], ["Role", int32_type], ["CreatedAt", string_type]]);
}

export class Guest extends Record {
    constructor(Id, EventId, FirstName, LastName, Gender, AgeCategory, AttendanceStatus, Title, Rank, DietaryNotes, DietaryTags, Wheelchair, Tags, Notes, RsvpStatus, RsvpRespondedAt, RsvpMealChoice, RsvpDietaryNotes, RsvpMessage, RsvpGuestToken, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Gender = (Gender | 0);
        this.AgeCategory = (AgeCategory | 0);
        this.AttendanceStatus = (AttendanceStatus | 0);
        this.Title = Title;
        this.Rank = Rank;
        this.DietaryNotes = DietaryNotes;
        this.DietaryTags = DietaryTags;
        this.Wheelchair = Wheelchair;
        this.Tags = Tags;
        this.Notes = Notes;
        this.RsvpStatus = (RsvpStatus | 0);
        this.RsvpRespondedAt = RsvpRespondedAt;
        this.RsvpMealChoice = RsvpMealChoice;
        this.RsvpDietaryNotes = RsvpDietaryNotes;
        this.RsvpMessage = RsvpMessage;
        this.RsvpGuestToken = RsvpGuestToken;
        this.Version = (Version | 0);
    }
}

export function Guest_$reflection() {
    return record_type("Shared.Guest", [], Guest, () => [["Id", string_type], ["EventId", string_type], ["FirstName", string_type], ["LastName", string_type], ["Gender", int32_type], ["AgeCategory", int32_type], ["AttendanceStatus", int32_type], ["Title", option_type(string_type)], ["Rank", option_type(int32_type)], ["DietaryNotes", option_type(string_type)], ["DietaryTags", option_type(string_type)], ["Wheelchair", bool_type], ["Tags", option_type(string_type)], ["Notes", option_type(string_type)], ["RsvpStatus", int32_type], ["RsvpRespondedAt", option_type(string_type)], ["RsvpMealChoice", option_type(string_type)], ["RsvpDietaryNotes", option_type(string_type)], ["RsvpMessage", option_type(string_type)], ["RsvpGuestToken", option_type(string_type)], ["Version", int32_type]]);
}

export class GuestPair extends Record {
    constructor(Id, EventId, Guest1Id, Guest2Id, PairType) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Guest1Id = Guest1Id;
        this.Guest2Id = Guest2Id;
        this.PairType = (PairType | 0);
    }
}

export function GuestPair_$reflection() {
    return record_type("Shared.GuestPair", [], GuestPair, () => [["Id", string_type], ["EventId", string_type], ["Guest1Id", string_type], ["Guest2Id", string_type], ["PairType", int32_type]]);
}

export class Family extends Record {
    constructor(Id, EventId, Name) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Name = Name;
    }
}

export function Family_$reflection() {
    return record_type("Shared.Family", [], Family, () => [["Id", string_type], ["EventId", string_type], ["Name", string_type]]);
}

export class FamilyMember extends Record {
    constructor(FamilyId, GuestId) {
        super();
        this.FamilyId = FamilyId;
        this.GuestId = GuestId;
    }
}

export function FamilyMember_$reflection() {
    return record_type("Shared.FamilyMember", [], FamilyMember, () => [["FamilyId", string_type], ["GuestId", string_type]]);
}

export class GuestGroup extends Record {
    constructor(Id, EventId, Name, GroupType) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Name = Name;
        this.GroupType = GroupType;
    }
}

export function GuestGroup_$reflection() {
    return record_type("Shared.GuestGroup", [], GuestGroup, () => [["Id", string_type], ["EventId", string_type], ["Name", string_type], ["GroupType", string_type]]);
}

export class GroupMember extends Record {
    constructor(GroupId, GuestId) {
        super();
        this.GroupId = GroupId;
        this.GuestId = GuestId;
    }
}

export function GroupMember_$reflection() {
    return record_type("Shared.GroupMember", [], GroupMember, () => [["GroupId", string_type], ["GuestId", string_type]]);
}

export class Table extends Record {
    constructor(Id, EventId, Name, Shape, Capacity, SeatsLongSide, SeatsShortEnd, SeatingStyle, IsHonorTable, SortOrder, PositionX, PositionY, Rotation, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Name = Name;
        this.Shape = (Shape | 0);
        this.Capacity = (Capacity | 0);
        this.SeatsLongSide = (SeatsLongSide | 0);
        this.SeatsShortEnd = (SeatsShortEnd | 0);
        this.SeatingStyle = (SeatingStyle | 0);
        this.IsHonorTable = IsHonorTable;
        this.SortOrder = (SortOrder | 0);
        this.PositionX = PositionX;
        this.PositionY = PositionY;
        this.Rotation = Rotation;
        this.Version = (Version | 0);
    }
}

export function Table_$reflection() {
    return record_type("Shared.Table", [], Table, () => [["Id", string_type], ["EventId", string_type], ["Name", string_type], ["Shape", int32_type], ["Capacity", int32_type], ["SeatsLongSide", int32_type], ["SeatsShortEnd", int32_type], ["SeatingStyle", int32_type], ["IsHonorTable", bool_type], ["SortOrder", int32_type], ["PositionX", float64_type], ["PositionY", float64_type], ["Rotation", float64_type], ["Version", int32_type]]);
}

export class SeatingRule extends Record {
    constructor(Id, EventId, RuleType, SubjectType, SubjectId, ObjectType, ObjectId, Parameter, IsHard, Priority, Description, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.RuleType = (RuleType | 0);
        this.SubjectType = SubjectType;
        this.SubjectId = SubjectId;
        this.ObjectType = ObjectType;
        this.ObjectId = ObjectId;
        this.Parameter = Parameter;
        this.IsHard = IsHard;
        this.Priority = (Priority | 0);
        this.Description = Description;
        this.Version = (Version | 0);
    }
}

export function SeatingRule_$reflection() {
    return record_type("Shared.SeatingRule", [], SeatingRule, () => [["Id", string_type], ["EventId", string_type], ["RuleType", int32_type], ["SubjectType", string_type], ["SubjectId", string_type], ["ObjectType", option_type(string_type)], ["ObjectId", option_type(string_type)], ["Parameter", option_type(int32_type)], ["IsHard", bool_type], ["Priority", int32_type], ["Description", option_type(string_type)], ["Version", int32_type]]);
}

export class Event$ extends Record {
    constructor(Id, UserId, Name, EventType, CulturePreset, EmptySeatStrategy, ExportTheme, ExportLayout, Date$, Notes, CreatedAt, UpdatedAt, Version) {
        super();
        this.Id = Id;
        this.UserId = UserId;
        this.Name = Name;
        this.EventType = (EventType | 0);
        this.CulturePreset = (CulturePreset | 0);
        this.EmptySeatStrategy = (EmptySeatStrategy | 0);
        this.ExportTheme = (ExportTheme | 0);
        this.ExportLayout = (ExportLayout | 0);
        this.Date = Date$;
        this.Notes = Notes;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.Version = (Version | 0);
    }
}

export function Event$_$reflection() {
    return record_type("Shared.Event", [], Event$, () => [["Id", string_type], ["UserId", string_type], ["Name", string_type], ["EventType", int32_type], ["CulturePreset", int32_type], ["EmptySeatStrategy", int32_type], ["ExportTheme", int32_type], ["ExportLayout", int32_type], ["Date", option_type(string_type)], ["Notes", option_type(string_type)], ["CreatedAt", string_type], ["UpdatedAt", string_type], ["Version", int32_type]]);
}

export class SeatAssignment extends Record {
    constructor(ArrangementId, GuestId, TableId, SeatNumber) {
        super();
        this.ArrangementId = ArrangementId;
        this.GuestId = GuestId;
        this.TableId = TableId;
        this.SeatNumber = (SeatNumber | 0);
    }
}

export function SeatAssignment_$reflection() {
    return record_type("Shared.SeatAssignment", [], SeatAssignment, () => [["ArrangementId", string_type], ["GuestId", string_type], ["TableId", string_type], ["SeatNumber", int32_type]]);
}

export class Arrangement extends Record {
    constructor(Id, EventId, Score, HardViolations, SoftViolations, SoftPenaltyDetails, IsOptimal, CreatedAt, IsSelected, IsLiked, SeatCount, Notes) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Score = Score;
        this.HardViolations = (HardViolations | 0);
        this.SoftViolations = (SoftViolations | 0);
        this.SoftPenaltyDetails = SoftPenaltyDetails;
        this.IsOptimal = IsOptimal;
        this.CreatedAt = CreatedAt;
        this.IsSelected = IsSelected;
        this.IsLiked = IsLiked;
        this.SeatCount = (SeatCount | 0);
        this.Notes = Notes;
    }
}

export function Arrangement_$reflection() {
    return record_type("Shared.Arrangement", [], Arrangement, () => [["Id", string_type], ["EventId", string_type], ["Score", float64_type], ["HardViolations", int32_type], ["SoftViolations", int32_type], ["SoftPenaltyDetails", list_type(string_type)], ["IsOptimal", bool_type], ["CreatedAt", string_type], ["IsSelected", bool_type], ["IsLiked", bool_type], ["SeatCount", int32_type], ["Notes", option_type(string_type)]]);
}

export class PublicLink extends Record {
    constructor(Id, EventId, ArrangementId, Token, LinkType, SecurityMode, Keyword, Pin, DisplayMode, WelcomeMessage, HeaderImageUrl, ExpiresAt, IsActive, LookupCount, CreatedAt, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.ArrangementId = ArrangementId;
        this.Token = Token;
        this.LinkType = (LinkType | 0);
        this.SecurityMode = (SecurityMode | 0);
        this.Keyword = Keyword;
        this.Pin = Pin;
        this.DisplayMode = (DisplayMode | 0);
        this.WelcomeMessage = WelcomeMessage;
        this.HeaderImageUrl = HeaderImageUrl;
        this.ExpiresAt = ExpiresAt;
        this.IsActive = IsActive;
        this.LookupCount = (LookupCount | 0);
        this.CreatedAt = CreatedAt;
        this.Version = (Version | 0);
    }
}

export function PublicLink_$reflection() {
    return record_type("Shared.PublicLink", [], PublicLink, () => [["Id", string_type], ["EventId", string_type], ["ArrangementId", string_type], ["Token", string_type], ["LinkType", int32_type], ["SecurityMode", int32_type], ["Keyword", option_type(string_type)], ["Pin", option_type(string_type)], ["DisplayMode", int32_type], ["WelcomeMessage", option_type(string_type)], ["HeaderImageUrl", option_type(string_type)], ["ExpiresAt", option_type(string_type)], ["IsActive", bool_type], ["LookupCount", int32_type], ["CreatedAt", string_type], ["Version", int32_type]]);
}

export class TrKey extends Union {
    constructor(Item1, Item2) {
        super();
        this.tag = 0;
        this.fields = [Item1, Item2];
    }
    cases() {
        return ["TrKey"];
    }
}

export function TrKey_$reflection() {
    return union_type("Shared.TrKey", [], TrKey, () => [[["Item1", string_type], ["Item2", list_type(string_type)]]]);
}

/**
 * Format a TrKey as a readable string (key + args). Useful for server-side
 * logging and MCP responses where the client translation module is unavailable.
 */
export function TrKeyModule_format(_arg) {
    const key = _arg.fields[0];
    const args = _arg.fields[1];
    if (isEmpty(args)) {
        return key;
    }
    else {
        return `${key} [${join(", ", args)}]`;
    }
}

export class ApiError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Unauthorized", "Forbidden", "ValidationError", "VersionConflict", "ArrangerError"];
    }
}

export function ApiError_$reflection() {
    return union_type("Shared.ApiError", [], ApiError, () => [[], [], [], [["Item", TrKey_$reflection()]], [], [["Item", TrKey_$reflection()]]]);
}

export class LoginRequest extends Record {
    constructor(Email, Password) {
        super();
        this.Email = Email;
        this.Password = Password;
    }
}

export function LoginRequest_$reflection() {
    return record_type("Shared.LoginRequest", [], LoginRequest, () => [["Email", string_type], ["Password", string_type]]);
}

export class RegisterRequest extends Record {
    constructor(Email, Password, TurnstileToken) {
        super();
        this.Email = Email;
        this.Password = Password;
        this.TurnstileToken = TurnstileToken;
    }
}

export function RegisterRequest_$reflection() {
    return record_type("Shared.RegisterRequest", [], RegisterRequest, () => [["Email", string_type], ["Password", string_type], ["TurnstileToken", string_type]]);
}

export class CreateEventRequest extends Record {
    constructor(Name, EventType, CulturePreset, EmptySeatStrategy, Date$, Notes) {
        super();
        this.Name = Name;
        this.EventType = (EventType | 0);
        this.CulturePreset = (CulturePreset | 0);
        this.EmptySeatStrategy = (EmptySeatStrategy | 0);
        this.Date = Date$;
        this.Notes = Notes;
    }
}

export function CreateEventRequest_$reflection() {
    return record_type("Shared.CreateEventRequest", [], CreateEventRequest, () => [["Name", string_type], ["EventType", int32_type], ["CulturePreset", int32_type], ["EmptySeatStrategy", int32_type], ["Date", option_type(string_type)], ["Notes", option_type(string_type)]]);
}

export class UpdateEventRequest extends Record {
    constructor(Id, Name, EventType, CulturePreset, EmptySeatStrategy, ExportTheme, ExportLayout, Date$, Notes, Version) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.EventType = (EventType | 0);
        this.CulturePreset = (CulturePreset | 0);
        this.EmptySeatStrategy = (EmptySeatStrategy | 0);
        this.ExportTheme = (ExportTheme | 0);
        this.ExportLayout = (ExportLayout | 0);
        this.Date = Date$;
        this.Notes = Notes;
        this.Version = (Version | 0);
    }
}

export function UpdateEventRequest_$reflection() {
    return record_type("Shared.UpdateEventRequest", [], UpdateEventRequest, () => [["Id", string_type], ["Name", string_type], ["EventType", int32_type], ["CulturePreset", int32_type], ["EmptySeatStrategy", int32_type], ["ExportTheme", int32_type], ["ExportLayout", int32_type], ["Date", option_type(string_type)], ["Notes", option_type(string_type)], ["Version", int32_type]]);
}

export class CreateGuestRequest extends Record {
    constructor(EventId, FirstName, LastName, Gender, AgeCategory, AttendanceStatus, Title, Rank, DietaryNotes, DietaryTags, Wheelchair, Tags, Notes) {
        super();
        this.EventId = EventId;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Gender = (Gender | 0);
        this.AgeCategory = (AgeCategory | 0);
        this.AttendanceStatus = (AttendanceStatus | 0);
        this.Title = Title;
        this.Rank = Rank;
        this.DietaryNotes = DietaryNotes;
        this.DietaryTags = DietaryTags;
        this.Wheelchair = Wheelchair;
        this.Tags = Tags;
        this.Notes = Notes;
    }
}

export function CreateGuestRequest_$reflection() {
    return record_type("Shared.CreateGuestRequest", [], CreateGuestRequest, () => [["EventId", string_type], ["FirstName", string_type], ["LastName", string_type], ["Gender", int32_type], ["AgeCategory", int32_type], ["AttendanceStatus", int32_type], ["Title", option_type(string_type)], ["Rank", option_type(int32_type)], ["DietaryNotes", option_type(string_type)], ["DietaryTags", option_type(string_type)], ["Wheelchair", bool_type], ["Tags", option_type(string_type)], ["Notes", option_type(string_type)]]);
}

export class UpdateGuestRequest extends Record {
    constructor(Id, FirstName, LastName, Gender, AgeCategory, AttendanceStatus, Title, Rank, DietaryNotes, DietaryTags, Wheelchair, Tags, Notes, Version) {
        super();
        this.Id = Id;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Gender = (Gender | 0);
        this.AgeCategory = (AgeCategory | 0);
        this.AttendanceStatus = (AttendanceStatus | 0);
        this.Title = Title;
        this.Rank = Rank;
        this.DietaryNotes = DietaryNotes;
        this.DietaryTags = DietaryTags;
        this.Wheelchair = Wheelchair;
        this.Tags = Tags;
        this.Notes = Notes;
        this.Version = (Version | 0);
    }
}

export function UpdateGuestRequest_$reflection() {
    return record_type("Shared.UpdateGuestRequest", [], UpdateGuestRequest, () => [["Id", string_type], ["FirstName", string_type], ["LastName", string_type], ["Gender", int32_type], ["AgeCategory", int32_type], ["AttendanceStatus", int32_type], ["Title", option_type(string_type)], ["Rank", option_type(int32_type)], ["DietaryNotes", option_type(string_type)], ["DietaryTags", option_type(string_type)], ["Wheelchair", bool_type], ["Tags", option_type(string_type)], ["Notes", option_type(string_type)], ["Version", int32_type]]);
}

export class CreateTableRequest extends Record {
    constructor(EventId, Name, Shape, Capacity, SeatsLongSide, SeatsShortEnd, SeatingStyle, IsHonorTable) {
        super();
        this.EventId = EventId;
        this.Name = Name;
        this.Shape = (Shape | 0);
        this.Capacity = (Capacity | 0);
        this.SeatsLongSide = (SeatsLongSide | 0);
        this.SeatsShortEnd = (SeatsShortEnd | 0);
        this.SeatingStyle = (SeatingStyle | 0);
        this.IsHonorTable = IsHonorTable;
    }
}

export function CreateTableRequest_$reflection() {
    return record_type("Shared.CreateTableRequest", [], CreateTableRequest, () => [["EventId", string_type], ["Name", string_type], ["Shape", int32_type], ["Capacity", int32_type], ["SeatsLongSide", int32_type], ["SeatsShortEnd", int32_type], ["SeatingStyle", int32_type], ["IsHonorTable", bool_type]]);
}

export class UpdateTableRequest extends Record {
    constructor(Id, Name, Shape, Capacity, SeatsLongSide, SeatsShortEnd, SeatingStyle, IsHonorTable, SortOrder, Version) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Shape = (Shape | 0);
        this.Capacity = (Capacity | 0);
        this.SeatsLongSide = (SeatsLongSide | 0);
        this.SeatsShortEnd = (SeatsShortEnd | 0);
        this.SeatingStyle = (SeatingStyle | 0);
        this.IsHonorTable = IsHonorTable;
        this.SortOrder = (SortOrder | 0);
        this.Version = (Version | 0);
    }
}

export function UpdateTableRequest_$reflection() {
    return record_type("Shared.UpdateTableRequest", [], UpdateTableRequest, () => [["Id", string_type], ["Name", string_type], ["Shape", int32_type], ["Capacity", int32_type], ["SeatsLongSide", int32_type], ["SeatsShortEnd", int32_type], ["SeatingStyle", int32_type], ["IsHonorTable", bool_type], ["SortOrder", int32_type], ["Version", int32_type]]);
}

export class UpdateTablePositionRequest extends Record {
    constructor(Id, EventId, PositionX, PositionY, Rotation, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.PositionX = PositionX;
        this.PositionY = PositionY;
        this.Rotation = Rotation;
        this.Version = (Version | 0);
    }
}

export function UpdateTablePositionRequest_$reflection() {
    return record_type("Shared.UpdateTablePositionRequest", [], UpdateTablePositionRequest, () => [["Id", string_type], ["EventId", string_type], ["PositionX", float64_type], ["PositionY", float64_type], ["Rotation", float64_type], ["Version", int32_type]]);
}

export class CreatePairRequest extends Record {
    constructor(EventId, Guest1Id, Guest2Id, PairType) {
        super();
        this.EventId = EventId;
        this.Guest1Id = Guest1Id;
        this.Guest2Id = Guest2Id;
        this.PairType = (PairType | 0);
    }
}

export function CreatePairRequest_$reflection() {
    return record_type("Shared.CreatePairRequest", [], CreatePairRequest, () => [["EventId", string_type], ["Guest1Id", string_type], ["Guest2Id", string_type], ["PairType", int32_type]]);
}

export class CreateFamilyRequest extends Record {
    constructor(EventId, Name, MemberIds) {
        super();
        this.EventId = EventId;
        this.Name = Name;
        this.MemberIds = MemberIds;
    }
}

export function CreateFamilyRequest_$reflection() {
    return record_type("Shared.CreateFamilyRequest", [], CreateFamilyRequest, () => [["EventId", string_type], ["Name", string_type], ["MemberIds", list_type(string_type)]]);
}

export class CreateGroupRequest extends Record {
    constructor(EventId, Name, GroupType, MemberIds) {
        super();
        this.EventId = EventId;
        this.Name = Name;
        this.GroupType = GroupType;
        this.MemberIds = MemberIds;
    }
}

export function CreateGroupRequest_$reflection() {
    return record_type("Shared.CreateGroupRequest", [], CreateGroupRequest, () => [["EventId", string_type], ["Name", string_type], ["GroupType", string_type], ["MemberIds", list_type(string_type)]]);
}

export class CreateRuleRequest extends Record {
    constructor(EventId, RuleType, SubjectType, SubjectId, ObjectType, ObjectId, Parameter, IsHard, Priority, Description) {
        super();
        this.EventId = EventId;
        this.RuleType = (RuleType | 0);
        this.SubjectType = SubjectType;
        this.SubjectId = SubjectId;
        this.ObjectType = ObjectType;
        this.ObjectId = ObjectId;
        this.Parameter = Parameter;
        this.IsHard = IsHard;
        this.Priority = (Priority | 0);
        this.Description = Description;
    }
}

export function CreateRuleRequest_$reflection() {
    return record_type("Shared.CreateRuleRequest", [], CreateRuleRequest, () => [["EventId", string_type], ["RuleType", int32_type], ["SubjectType", string_type], ["SubjectId", string_type], ["ObjectType", option_type(string_type)], ["ObjectId", option_type(string_type)], ["Parameter", option_type(int32_type)], ["IsHard", bool_type], ["Priority", int32_type], ["Description", option_type(string_type)]]);
}

export class ArrangementFeedback extends Record {
    constructor(Id, ArrangementId, UserId, Rating, Reason, FlaggedSeatGuestId, FlaggedSeatTableId, CreatedAt) {
        super();
        this.Id = Id;
        this.ArrangementId = ArrangementId;
        this.UserId = UserId;
        this.Rating = (Rating | 0);
        this.Reason = Reason;
        this.FlaggedSeatGuestId = FlaggedSeatGuestId;
        this.FlaggedSeatTableId = FlaggedSeatTableId;
        this.CreatedAt = CreatedAt;
    }
}

export function ArrangementFeedback_$reflection() {
    return record_type("Shared.ArrangementFeedback", [], ArrangementFeedback, () => [["Id", string_type], ["ArrangementId", string_type], ["UserId", string_type], ["Rating", int32_type], ["Reason", option_type(string_type)], ["FlaggedSeatGuestId", option_type(string_type)], ["FlaggedSeatTableId", option_type(string_type)], ["CreatedAt", string_type]]);
}

export class RateArrangementRequest extends Record {
    constructor(ArrangementId, Rating, Reason, FlaggedSeatGuestId, FlaggedSeatTableId) {
        super();
        this.ArrangementId = ArrangementId;
        this.Rating = (Rating | 0);
        this.Reason = Reason;
        this.FlaggedSeatGuestId = FlaggedSeatGuestId;
        this.FlaggedSeatTableId = FlaggedSeatTableId;
    }
}

export function RateArrangementRequest_$reflection() {
    return record_type("Shared.RateArrangementRequest", [], RateArrangementRequest, () => [["ArrangementId", string_type], ["Rating", int32_type], ["Reason", option_type(string_type)], ["FlaggedSeatGuestId", option_type(string_type)], ["FlaggedSeatTableId", option_type(string_type)]]);
}

export class ArrangeRequest extends Record {
    constructor(EventId, Count, Seed, TimeoutSeconds, SolverBackend, EmptySeatStrategy) {
        super();
        this.EventId = EventId;
        this.Count = (Count | 0);
        this.Seed = Seed;
        this.TimeoutSeconds = (TimeoutSeconds | 0);
        this.SolverBackend = (SolverBackend | 0);
        this.EmptySeatStrategy = (EmptySeatStrategy | 0);
    }
}

export function ArrangeRequest_$reflection() {
    return record_type("Shared.ArrangeRequest", [], ArrangeRequest, () => [["EventId", string_type], ["Count", int32_type], ["Seed", option_type(int32_type)], ["TimeoutSeconds", int32_type], ["SolverBackend", int32_type], ["EmptySeatStrategy", int32_type]]);
}

export class ArrangeResponse extends Record {
    constructor(Arrangements, WasInterrupted, Message) {
        super();
        this.Arrangements = Arrangements;
        this.WasInterrupted = WasInterrupted;
        this.Message = Message;
    }
}

export function ArrangeResponse_$reflection() {
    return record_type("Shared.ArrangeResponse", [], ArrangeResponse, () => [["Arrangements", list_type(Arrangement_$reflection())], ["WasInterrupted", bool_type], ["Message", option_type(TrKey_$reflection())]]);
}

export class LockSeatRequest extends Record {
    constructor(EventId, GuestId, TableId, SeatNumber) {
        super();
        this.EventId = EventId;
        this.GuestId = GuestId;
        this.TableId = TableId;
        this.SeatNumber = (SeatNumber | 0);
    }
}

export function LockSeatRequest_$reflection() {
    return record_type("Shared.LockSeatRequest", [], LockSeatRequest, () => [["EventId", string_type], ["GuestId", string_type], ["TableId", string_type], ["SeatNumber", int32_type]]);
}

export class UpdateProfileRequest extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function UpdateProfileRequest_$reflection() {
    return record_type("Shared.UpdateProfileRequest", [], UpdateProfileRequest, () => [["Name", string_type]]);
}

export class ChangePasswordRequest extends Record {
    constructor(CurrentPassword, NewPassword) {
        super();
        this.CurrentPassword = CurrentPassword;
        this.NewPassword = NewPassword;
    }
}

export function ChangePasswordRequest_$reflection() {
    return record_type("Shared.ChangePasswordRequest", [], ChangePasswordRequest, () => [["CurrentPassword", option_type(string_type)], ["NewPassword", string_type]]);
}

export class TagType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GeneralTag", "DietaryTag"];
    }
}

export function TagType_$reflection() {
    return union_type("Shared.TagType", [], TagType, () => [[], []]);
}

export function TagTypeModule_toInt(_arg) {
    if (_arg.tag === 1) {
        return 1;
    }
    else {
        return 0;
    }
}

export function TagTypeModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new TagType(0, []);
        case 1:
            return new TagType(1, []);
        default:
            return new TagType(0, []);
    }
}

export class DietaryCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Diet", "Religious", "Allergy", "Medical", "OtherDietary"];
    }
}

export function DietaryCategory_$reflection() {
    return union_type("Shared.DietaryCategory", [], DietaryCategory, () => [[], [], [], [], []]);
}

export function DietaryCategoryModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

export function DietaryCategoryModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new DietaryCategory(0, []);
        case 1:
            return new DietaryCategory(1, []);
        case 2:
            return new DietaryCategory(2, []);
        case 3:
            return new DietaryCategory(3, []);
        case 4:
            return new DietaryCategory(4, []);
        default:
            return new DietaryCategory(4, []);
    }
}

export class DietaryOption extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Vegetarian", "Vegan", "Pescatarian", "NoRedMeat", "NoPork", "Halal", "Kosher", "HinduVeg", "GlutenFree", "LactoseFree", "DairyFree", "NutFree", "ShellfishFree", "EggFree", "SoyFree", "Diabetic", "LowSodium", "NoAlcohol"];
    }
}

export function DietaryOption_$reflection() {
    return union_type("Shared.DietaryOption", [], DietaryOption, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function DietaryOptionModule_toCode(_arg) {
    switch (_arg.tag) {
        case 1:
            return "Vegan";
        case 2:
            return "Pescatarian";
        case 3:
            return "NoRedMeat";
        case 4:
            return "NoPork";
        case 5:
            return "Halal";
        case 6:
            return "Kosher";
        case 7:
            return "HinduVeg";
        case 8:
            return "GlutenFree";
        case 9:
            return "LactoseFree";
        case 10:
            return "DairyFree";
        case 11:
            return "NutFree";
        case 12:
            return "ShellfishFree";
        case 13:
            return "EggFree";
        case 14:
            return "SoyFree";
        case 15:
            return "Diabetic";
        case 16:
            return "LowSodium";
        case 17:
            return "NoAlcohol";
        default:
            return "Vegetarian";
    }
}

export function DietaryOptionModule_fromCode(s) {
    switch (s) {
        case "Vegetarian":
            return new DietaryOption(0, []);
        case "Vegan":
            return new DietaryOption(1, []);
        case "Pescatarian":
            return new DietaryOption(2, []);
        case "NoRedMeat":
            return new DietaryOption(3, []);
        case "NoPork":
            return new DietaryOption(4, []);
        case "Halal":
            return new DietaryOption(5, []);
        case "Kosher":
            return new DietaryOption(6, []);
        case "HinduVeg":
            return new DietaryOption(7, []);
        case "GlutenFree":
            return new DietaryOption(8, []);
        case "LactoseFree":
            return new DietaryOption(9, []);
        case "DairyFree":
            return new DietaryOption(10, []);
        case "NutFree":
            return new DietaryOption(11, []);
        case "ShellfishFree":
            return new DietaryOption(12, []);
        case "EggFree":
            return new DietaryOption(13, []);
        case "SoyFree":
            return new DietaryOption(14, []);
        case "Diabetic":
            return new DietaryOption(15, []);
        case "LowSodium":
            return new DietaryOption(16, []);
        case "NoAlcohol":
            return new DietaryOption(17, []);
        default:
            return undefined;
    }
}

export function DietaryOptionModule_category(_arg) {
    switch (_arg.tag) {
        case 1:
            return new DietaryCategory(0, []);
        case 2:
            return new DietaryCategory(0, []);
        case 3:
            return new DietaryCategory(0, []);
        case 4:
            return new DietaryCategory(0, []);
        case 5:
            return new DietaryCategory(1, []);
        case 6:
            return new DietaryCategory(1, []);
        case 7:
            return new DietaryCategory(1, []);
        case 8:
            return new DietaryCategory(2, []);
        case 9:
            return new DietaryCategory(2, []);
        case 10:
            return new DietaryCategory(2, []);
        case 11:
            return new DietaryCategory(2, []);
        case 12:
            return new DietaryCategory(2, []);
        case 13:
            return new DietaryCategory(2, []);
        case 14:
            return new DietaryCategory(2, []);
        case 15:
            return new DietaryCategory(3, []);
        case 16:
            return new DietaryCategory(3, []);
        case 17:
            return new DietaryCategory(4, []);
        default:
            return new DietaryCategory(0, []);
    }
}

export function DietaryOptionModule_nameKey(_arg) {
    switch (_arg.tag) {
        case 1:
            return Dietary_vegan;
        case 2:
            return Dietary_pescatarian;
        case 3:
            return Dietary_noRedMeat;
        case 4:
            return Dietary_noPork;
        case 5:
            return Dietary_halal;
        case 6:
            return Dietary_kosher;
        case 7:
            return Dietary_hinduVeg;
        case 8:
            return Dietary_glutenFree;
        case 9:
            return Dietary_lactoseFree;
        case 10:
            return Dietary_dairyFree;
        case 11:
            return Dietary_nutFree;
        case 12:
            return Dietary_shellfishFree;
        case 13:
            return Dietary_eggFree;
        case 14:
            return Dietary_soyFree;
        case 15:
            return Dietary_diabetic;
        case 16:
            return Dietary_lowSodium;
        case 17:
            return Dietary_noAlcohol;
        default:
            return Dietary_vegetarian;
    }
}

export function DietaryOptionModule_descriptionKey(_arg) {
    switch (_arg.tag) {
        case 1:
            return Dietary_veganDesc;
        case 2:
            return Dietary_pescatarianDesc;
        case 3:
            return Dietary_noRedMeatDesc;
        case 4:
            return Dietary_noPorkDesc;
        case 5:
            return Dietary_halalDesc;
        case 6:
            return Dietary_kosherDesc;
        case 7:
            return Dietary_hinduVegDesc;
        case 8:
            return Dietary_glutenFreeDesc;
        case 9:
            return Dietary_lactoseFreeDesc;
        case 10:
            return Dietary_dairyFreeDesc;
        case 11:
            return Dietary_nutFreeDesc;
        case 12:
            return Dietary_shellfishFreeDesc;
        case 13:
            return Dietary_eggFreeDesc;
        case 14:
            return Dietary_soyFreeDesc;
        case 15:
            return Dietary_diabeticDesc;
        case 16:
            return Dietary_lowSodiumDesc;
        case 17:
            return Dietary_noAlcoholDesc;
        default:
            return Dietary_vegetarianDesc;
    }
}

export const DietaryOptionModule_allOptions = ofArray([new DietaryOption(0, []), new DietaryOption(1, []), new DietaryOption(2, []), new DietaryOption(3, []), new DietaryOption(4, []), new DietaryOption(5, []), new DietaryOption(6, []), new DietaryOption(7, []), new DietaryOption(8, []), new DietaryOption(9, []), new DietaryOption(10, []), new DietaryOption(11, []), new DietaryOption(12, []), new DietaryOption(13, []), new DietaryOption(14, []), new DietaryOption(15, []), new DietaryOption(16, []), new DietaryOption(17, [])]);

/**
 * Parse `,TAG1,TAG2,` format into a trimmed list, case-insensitive dedup (keeps first occurrence).
 */
export function TagFormat_parse(raw) {
    let s, array_1;
    if (raw != null) {
        if ((s = raw, s.trim() === "")) {
            const s_1 = raw;
            return empty();
        }
        else {
            const s_2 = raw;
            return fold((acc, tag) => {
                if (exists((t_2) => (compare_1(t_2, tag, 5) === 0), acc)) {
                    return acc;
                }
                else {
                    return append(acc, singleton(tag));
                }
            }, empty(), ofArray((array_1 = map((t) => t.trim(), split(s_2, [","], undefined, 0)), array_1.filter((t_1) => (t_1 !== "")))));
        }
    }
    else {
        return empty();
    }
}

/**
 * Join a tag list into `,TAG1,TAG2,` format. Returns None if empty.
 */
export function TagFormat_join(tags) {
    const filtered = filter((t_1) => (t_1 !== ""), map_1((t) => t.trim(), tags));
    if (isEmpty(filtered)) {
        return undefined;
    }
    else {
        return ("," + join(",", filtered)) + ",";
    }
}

/**
 * Convert legacy "A, B" format to new ",A,B," format.
 */
export function TagFormat_fromLegacy(raw) {
    let s, array_1;
    if (raw != null) {
        if ((s = raw, s.trim() === "")) {
            const s_1 = raw;
            return undefined;
        }
        else {
            const s_2 = raw;
            return TagFormat_join(ofArray((array_1 = map((t) => t.trim(), split(s_2, [","], undefined, 0)), array_1.filter((t_1) => (t_1 !== "")))));
        }
    }
    else {
        return undefined;
    }
}

/**
 * Convert new ",A,B," format to legacy display "A, B" for UI rendering.
 */
export function TagFormat_toDisplay(raw) {
    return join(", ", TagFormat_parse(raw));
}

export class Tag extends Record {
    constructor(Id, EventId, Name, Description, TagType, TagGroup, CreatedAt) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.Name = Name;
        this.Description = Description;
        this.TagType = (TagType | 0);
        this.TagGroup = (TagGroup | 0);
        this.CreatedAt = CreatedAt;
    }
}

export function Tag_$reflection() {
    return record_type("Shared.Tag", [], Tag, () => [["Id", string_type], ["EventId", string_type], ["Name", string_type], ["Description", option_type(string_type)], ["TagType", int32_type], ["TagGroup", int32_type], ["CreatedAt", string_type]]);
}

export class TagGroupStrategyEntry extends Record {
    constructor(TagGroup, Strategy) {
        super();
        this.TagGroup = (TagGroup | 0);
        this.Strategy = (Strategy | 0);
    }
}

export function TagGroupStrategyEntry_$reflection() {
    return record_type("Shared.TagGroupStrategyEntry", [], TagGroupStrategyEntry, () => [["TagGroup", int32_type], ["Strategy", int32_type]]);
}

export class SaveTagGroupStrategiesRequest extends Record {
    constructor(EventId, Strategies) {
        super();
        this.EventId = EventId;
        this.Strategies = Strategies;
    }
}

export function SaveTagGroupStrategiesRequest_$reflection() {
    return record_type("Shared.SaveTagGroupStrategiesRequest", [], SaveTagGroupStrategiesRequest, () => [["EventId", string_type], ["Strategies", list_type(TagGroupStrategyEntry_$reflection())]]);
}

export class CreateTagRequest extends Record {
    constructor(EventId, Name, Description, TagType, TagGroup) {
        super();
        this.EventId = EventId;
        this.Name = Name;
        this.Description = Description;
        this.TagType = (TagType | 0);
        this.TagGroup = (TagGroup | 0);
    }
}

export function CreateTagRequest_$reflection() {
    return record_type("Shared.CreateTagRequest", [], CreateTagRequest, () => [["EventId", string_type], ["Name", string_type], ["Description", option_type(string_type)], ["TagType", int32_type], ["TagGroup", int32_type]]);
}

export class UpdateTagRequest extends Record {
    constructor(Id, Name, Description, TagGroup) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.TagGroup = (TagGroup | 0);
    }
}

export function UpdateTagRequest_$reflection() {
    return record_type("Shared.UpdateTagRequest", [], UpdateTagRequest, () => [["Id", string_type], ["Name", string_type], ["Description", option_type(string_type)], ["TagGroup", int32_type]]);
}

export class TagOperation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RenameTag", "MergeTags", "DeleteTag"];
    }
}

export function TagOperation_$reflection() {
    return union_type("Shared.TagOperation", [], TagOperation, () => [[], [], []]);
}

export function TagOperationModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function TagOperationModule_fromInt(_arg) {
    switch (_arg) {
        case 0:
            return new TagOperation(0, []);
        case 1:
            return new TagOperation(1, []);
        case 2:
            return new TagOperation(2, []);
        default:
            return new TagOperation(0, []);
    }
}

export class UpdateGuestTagsRequest extends Record {
    constructor(EventId, Operation, OldTag, NewTag) {
        super();
        this.EventId = EventId;
        this.Operation = (Operation | 0);
        this.OldTag = OldTag;
        this.NewTag = NewTag;
    }
}

export function UpdateGuestTagsRequest_$reflection() {
    return record_type("Shared.UpdateGuestTagsRequest", [], UpdateGuestTagsRequest, () => [["EventId", string_type], ["Operation", int32_type], ["OldTag", string_type], ["NewTag", option_type(string_type)]]);
}

export class CloneGuestsRequest extends Record {
    constructor(SourceEventId, TargetEventId, IncludeRelationships) {
        super();
        this.SourceEventId = SourceEventId;
        this.TargetEventId = TargetEventId;
        this.IncludeRelationships = IncludeRelationships;
    }
}

export function CloneGuestsRequest_$reflection() {
    return record_type("Shared.CloneGuestsRequest", [], CloneGuestsRequest, () => [["SourceEventId", string_type], ["TargetEventId", string_type], ["IncludeRelationships", bool_type]]);
}

export class RsvpConfig extends Record {
    constructor(Id, EventId, IsOpen, Deadline, AllowPlusOne, MealOptions, CustomFields, ConfirmationMessage, ReminderSentAt, CreatedAt, Version) {
        super();
        this.Id = Id;
        this.EventId = EventId;
        this.IsOpen = IsOpen;
        this.Deadline = Deadline;
        this.AllowPlusOne = AllowPlusOne;
        this.MealOptions = MealOptions;
        this.CustomFields = CustomFields;
        this.ConfirmationMessage = ConfirmationMessage;
        this.ReminderSentAt = ReminderSentAt;
        this.CreatedAt = CreatedAt;
        this.Version = (Version | 0);
    }
}

export function RsvpConfig_$reflection() {
    return record_type("Shared.RsvpConfig", [], RsvpConfig, () => [["Id", string_type], ["EventId", string_type], ["IsOpen", bool_type], ["Deadline", option_type(string_type)], ["AllowPlusOne", bool_type], ["MealOptions", option_type(string_type)], ["CustomFields", option_type(string_type)], ["ConfirmationMessage", option_type(string_type)], ["ReminderSentAt", option_type(string_type)], ["CreatedAt", string_type], ["Version", int32_type]]);
}

export class RsvpAudit extends Record {
    constructor(Id, GuestId, FieldChanged, OldValue, NewValue, IpAddress, CreatedAt) {
        super();
        this.Id = Id;
        this.GuestId = GuestId;
        this.FieldChanged = FieldChanged;
        this.OldValue = OldValue;
        this.NewValue = NewValue;
        this.IpAddress = IpAddress;
        this.CreatedAt = CreatedAt;
    }
}

export function RsvpAudit_$reflection() {
    return record_type("Shared.RsvpAudit", [], RsvpAudit, () => [["Id", string_type], ["GuestId", string_type], ["FieldChanged", string_type], ["OldValue", option_type(string_type)], ["NewValue", option_type(string_type)], ["IpAddress", option_type(string_type)], ["CreatedAt", string_type]]);
}

export class RsvpSubmitRequest extends Record {
    constructor(GuestToken, Attending, MealChoice, DietaryNotes, Message, TablePreference) {
        super();
        this.GuestToken = GuestToken;
        this.Attending = (Attending | 0);
        this.MealChoice = MealChoice;
        this.DietaryNotes = DietaryNotes;
        this.Message = Message;
        this.TablePreference = TablePreference;
    }
}

export function RsvpSubmitRequest_$reflection() {
    return record_type("Shared.RsvpSubmitRequest", [], RsvpSubmitRequest, () => [["GuestToken", string_type], ["Attending", int32_type], ["MealChoice", option_type(string_type)], ["DietaryNotes", option_type(string_type)], ["Message", option_type(string_type)], ["TablePreference", option_type(string_type)]]);
}

export class RsvpSubmitResponse extends Record {
    constructor(GuestName, Status, ConfirmationMessage) {
        super();
        this.GuestName = GuestName;
        this.Status = (Status | 0);
        this.ConfirmationMessage = ConfirmationMessage;
    }
}

export function RsvpSubmitResponse_$reflection() {
    return record_type("Shared.RsvpSubmitResponse", [], RsvpSubmitResponse, () => [["GuestName", string_type], ["Status", int32_type], ["ConfirmationMessage", option_type(string_type)]]);
}

export class RsvpStatusResponse extends Record {
    constructor(GuestName, Status, MealChoice, DietaryNotes, Message, RespondedAt) {
        super();
        this.GuestName = GuestName;
        this.Status = (Status | 0);
        this.MealChoice = MealChoice;
        this.DietaryNotes = DietaryNotes;
        this.Message = Message;
        this.RespondedAt = RespondedAt;
    }
}

export function RsvpStatusResponse_$reflection() {
    return record_type("Shared.RsvpStatusResponse", [], RsvpStatusResponse, () => [["GuestName", string_type], ["Status", int32_type], ["MealChoice", option_type(string_type)], ["DietaryNotes", option_type(string_type)], ["Message", option_type(string_type)], ["RespondedAt", option_type(string_type)]]);
}

export class RsvpGuestInfo extends Record {
    constructor(GuestToken, GuestName, Status, MealChoice, DietaryNotes, EventName, EventDate, MealOptions, AllowPlusOne, IsOpen, Deadline, ConfirmationMessage) {
        super();
        this.GuestToken = GuestToken;
        this.GuestName = GuestName;
        this.Status = (Status | 0);
        this.MealChoice = MealChoice;
        this.DietaryNotes = DietaryNotes;
        this.EventName = EventName;
        this.EventDate = EventDate;
        this.MealOptions = MealOptions;
        this.AllowPlusOne = AllowPlusOne;
        this.IsOpen = IsOpen;
        this.Deadline = Deadline;
        this.ConfirmationMessage = ConfirmationMessage;
    }
}

export function RsvpGuestInfo_$reflection() {
    return record_type("Shared.RsvpGuestInfo", [], RsvpGuestInfo, () => [["GuestToken", string_type], ["GuestName", string_type], ["Status", int32_type], ["MealChoice", option_type(string_type)], ["DietaryNotes", option_type(string_type)], ["EventName", string_type], ["EventDate", option_type(string_type)], ["MealOptions", list_type(string_type)], ["AllowPlusOne", bool_type], ["IsOpen", bool_type], ["Deadline", option_type(string_type)], ["ConfirmationMessage", option_type(string_type)]]);
}

export class RsvpSummary extends Record {
    constructor(TotalGuests, Accepted, Declined, Maybe, Pending, NotSent, MealCounts) {
        super();
        this.TotalGuests = (TotalGuests | 0);
        this.Accepted = (Accepted | 0);
        this.Declined = (Declined | 0);
        this.Maybe = (Maybe | 0);
        this.Pending = (Pending | 0);
        this.NotSent = (NotSent | 0);
        this.MealCounts = MealCounts;
    }
}

export function RsvpSummary_$reflection() {
    return record_type("Shared.RsvpSummary", [], RsvpSummary, () => [["TotalGuests", int32_type], ["Accepted", int32_type], ["Declined", int32_type], ["Maybe", int32_type], ["Pending", int32_type], ["NotSent", int32_type], ["MealCounts", list_type(tuple_type(string_type, int32_type))]]);
}

export class SaveRsvpConfigRequest extends Record {
    constructor(EventId, IsOpen, Deadline, AllowPlusOne, MealOptions, ConfirmationMessage) {
        super();
        this.EventId = EventId;
        this.IsOpen = IsOpen;
        this.Deadline = Deadline;
        this.AllowPlusOne = AllowPlusOne;
        this.MealOptions = MealOptions;
        this.ConfirmationMessage = ConfirmationMessage;
    }
}

export function SaveRsvpConfigRequest_$reflection() {
    return record_type("Shared.SaveRsvpConfigRequest", [], SaveRsvpConfigRequest, () => [["EventId", string_type], ["IsOpen", bool_type], ["Deadline", option_type(string_type)], ["AllowPlusOne", bool_type], ["MealOptions", list_type(string_type)], ["ConfirmationMessage", option_type(string_type)]]);
}

export class RsvpGuestLink extends Record {
    constructor(GuestId, GuestName, GuestToken, Status) {
        super();
        this.GuestId = GuestId;
        this.GuestName = GuestName;
        this.GuestToken = GuestToken;
        this.Status = (Status | 0);
    }
}

export function RsvpGuestLink_$reflection() {
    return record_type("Shared.RsvpGuestLink", [], RsvpGuestLink, () => [["GuestId", string_type], ["GuestName", string_type], ["GuestToken", string_type], ["Status", int32_type]]);
}

export class CreatePublicLinkRequest extends Record {
    constructor(EventId, ArrangementId, LinkType, SecurityMode, DisplayMode, Keyword, Pin, WelcomeMessage, ExpiresAt) {
        super();
        this.EventId = EventId;
        this.ArrangementId = ArrangementId;
        this.LinkType = (LinkType | 0);
        this.SecurityMode = (SecurityMode | 0);
        this.DisplayMode = (DisplayMode | 0);
        this.Keyword = Keyword;
        this.Pin = Pin;
        this.WelcomeMessage = WelcomeMessage;
        this.ExpiresAt = ExpiresAt;
    }
}

export function CreatePublicLinkRequest_$reflection() {
    return record_type("Shared.CreatePublicLinkRequest", [], CreatePublicLinkRequest, () => [["EventId", string_type], ["ArrangementId", string_type], ["LinkType", int32_type], ["SecurityMode", int32_type], ["DisplayMode", int32_type], ["Keyword", option_type(string_type)], ["Pin", option_type(string_type)], ["WelcomeMessage", option_type(string_type)], ["ExpiresAt", option_type(string_type)]]);
}

export class UpdatePublicLinkRequest extends Record {
    constructor(Id, SecurityMode, DisplayMode, Keyword, Pin, WelcomeMessage, ExpiresAt, IsActive, Version) {
        super();
        this.Id = Id;
        this.SecurityMode = (SecurityMode | 0);
        this.DisplayMode = (DisplayMode | 0);
        this.Keyword = Keyword;
        this.Pin = Pin;
        this.WelcomeMessage = WelcomeMessage;
        this.ExpiresAt = ExpiresAt;
        this.IsActive = IsActive;
        this.Version = (Version | 0);
    }
}

export function UpdatePublicLinkRequest_$reflection() {
    return record_type("Shared.UpdatePublicLinkRequest", [], UpdatePublicLinkRequest, () => [["Id", string_type], ["SecurityMode", int32_type], ["DisplayMode", int32_type], ["Keyword", option_type(string_type)], ["Pin", option_type(string_type)], ["WelcomeMessage", option_type(string_type)], ["ExpiresAt", option_type(string_type)], ["IsActive", bool_type], ["Version", int32_type]]);
}

export class FindSeatRequest extends Record {
    constructor(Token, GuestName, Keyword, Pin) {
        super();
        this.Token = Token;
        this.GuestName = GuestName;
        this.Keyword = Keyword;
        this.Pin = Pin;
    }
}

export function FindSeatRequest_$reflection() {
    return record_type("Shared.FindSeatRequest", [], FindSeatRequest, () => [["Token", string_type], ["GuestName", string_type], ["Keyword", option_type(string_type)], ["Pin", option_type(string_type)]]);
}

export class FindSeatResponse extends Record {
    constructor(Found, GuestFirstName, TableName, TableNumber, NeighborFirstNames, MealChoice, WelcomeMessage, ErrorCode, ErrorMessage) {
        super();
        this.Found = Found;
        this.GuestFirstName = GuestFirstName;
        this.TableName = TableName;
        this.TableNumber = TableNumber;
        this.NeighborFirstNames = NeighborFirstNames;
        this.MealChoice = MealChoice;
        this.WelcomeMessage = WelcomeMessage;
        this.ErrorCode = ErrorCode;
        this.ErrorMessage = ErrorMessage;
    }
}

export function FindSeatResponse_$reflection() {
    return record_type("Shared.FindSeatResponse", [], FindSeatResponse, () => [["Found", bool_type], ["GuestFirstName", option_type(string_type)], ["TableName", option_type(string_type)], ["TableNumber", option_type(int32_type)], ["NeighborFirstNames", option_type(list_type(string_type))], ["MealChoice", option_type(string_type)], ["WelcomeMessage", option_type(string_type)], ["ErrorCode", option_type(string_type)], ["ErrorMessage", option_type(string_type)]]);
}

export class WidgetThemeConfig extends Record {
    constructor(AccentColor, HeaderImage) {
        super();
        this.AccentColor = AccentColor;
        this.HeaderImage = HeaderImage;
    }
}

export function WidgetThemeConfig_$reflection() {
    return record_type("Shared.WidgetThemeConfig", [], WidgetThemeConfig, () => [["AccentColor", option_type(string_type)], ["HeaderImage", option_type(string_type)]]);
}

export class WidgetConfig extends Record {
    constructor(EventName, EventDate, SecurityMode, DisplayMode, WelcomeMessage, TableCount, GuestCount, Theme) {
        super();
        this.EventName = EventName;
        this.EventDate = EventDate;
        this.SecurityMode = SecurityMode;
        this.DisplayMode = DisplayMode;
        this.WelcomeMessage = WelcomeMessage;
        this.TableCount = (TableCount | 0);
        this.GuestCount = (GuestCount | 0);
        this.Theme = Theme;
    }
}

export function WidgetConfig_$reflection() {
    return record_type("Shared.WidgetConfig", [], WidgetConfig, () => [["EventName", string_type], ["EventDate", option_type(string_type)], ["SecurityMode", string_type], ["DisplayMode", string_type], ["WelcomeMessage", option_type(string_type)], ["TableCount", int32_type], ["GuestCount", int32_type], ["Theme", WidgetThemeConfig_$reflection()]]);
}

export class ITablePlannerApi extends Record {
    constructor(login, register, me, getEvents, getEvent, createEvent, updateEvent, deleteEvent, getGuests, createGuest, updateGuest, deleteGuest, importGuests, updateGuestTags, cloneGuestsFromEvent, getPairs, createPair, deletePair, getFamilies, createFamily, deleteFamily, getGroups, createGroup, deleteGroup, getTables, createTable, updateTable, updateTablePosition, deleteTable, getRules, createRule, deleteRule, getWeights, saveWeights, arrange, cancelArrange, getArrangements, getArrangement, selectArrangement, lockSeat, unlockSeat, likeArrangement, unlikeArrangement, setArrangementNotes, rateArrangement, getArrangementFeedback, updateProfile, changePassword, deleteAccount, getConnectedProviders, hasPassword, getTags, createTag, updateTag, deleteTag, getTagGroupStrategies, saveTagGroupStrategies, getRsvpConfig, saveRsvpConfig, getRsvpSummary, getRsvpGuestLinks, generateRsvpTokens, getPublicLinks, createPublicLink, updatePublicLink, deletePublicLink, getAuthMode, getDebugUsers, debugLogin) {
        super();
        this.login = login;
        this.register = register;
        this.me = me;
        this.getEvents = getEvents;
        this.getEvent = getEvent;
        this.createEvent = createEvent;
        this.updateEvent = updateEvent;
        this.deleteEvent = deleteEvent;
        this.getGuests = getGuests;
        this.createGuest = createGuest;
        this.updateGuest = updateGuest;
        this.deleteGuest = deleteGuest;
        this.importGuests = importGuests;
        this.updateGuestTags = updateGuestTags;
        this.cloneGuestsFromEvent = cloneGuestsFromEvent;
        this.getPairs = getPairs;
        this.createPair = createPair;
        this.deletePair = deletePair;
        this.getFamilies = getFamilies;
        this.createFamily = createFamily;
        this.deleteFamily = deleteFamily;
        this.getGroups = getGroups;
        this.createGroup = createGroup;
        this.deleteGroup = deleteGroup;
        this.getTables = getTables;
        this.createTable = createTable;
        this.updateTable = updateTable;
        this.updateTablePosition = updateTablePosition;
        this.deleteTable = deleteTable;
        this.getRules = getRules;
        this.createRule = createRule;
        this.deleteRule = deleteRule;
        this.getWeights = getWeights;
        this.saveWeights = saveWeights;
        this.arrange = arrange;
        this.cancelArrange = cancelArrange;
        this.getArrangements = getArrangements;
        this.getArrangement = getArrangement;
        this.selectArrangement = selectArrangement;
        this.lockSeat = lockSeat;
        this.unlockSeat = unlockSeat;
        this.likeArrangement = likeArrangement;
        this.unlikeArrangement = unlikeArrangement;
        this.setArrangementNotes = setArrangementNotes;
        this.rateArrangement = rateArrangement;
        this.getArrangementFeedback = getArrangementFeedback;
        this.updateProfile = updateProfile;
        this.changePassword = changePassword;
        this.deleteAccount = deleteAccount;
        this.getConnectedProviders = getConnectedProviders;
        this.hasPassword = hasPassword;
        this.getTags = getTags;
        this.createTag = createTag;
        this.updateTag = updateTag;
        this.deleteTag = deleteTag;
        this.getTagGroupStrategies = getTagGroupStrategies;
        this.saveTagGroupStrategies = saveTagGroupStrategies;
        this.getRsvpConfig = getRsvpConfig;
        this.saveRsvpConfig = saveRsvpConfig;
        this.getRsvpSummary = getRsvpSummary;
        this.getRsvpGuestLinks = getRsvpGuestLinks;
        this.generateRsvpTokens = generateRsvpTokens;
        this.getPublicLinks = getPublicLinks;
        this.createPublicLink = createPublicLink;
        this.updatePublicLink = updatePublicLink;
        this.deletePublicLink = deletePublicLink;
        this.getAuthMode = getAuthMode;
        this.getDebugUsers = getDebugUsers;
        this.debugLogin = debugLogin;
    }
}

export function ITablePlannerApi_$reflection() {
    return record_type("Shared.ITablePlannerApi", [], ITablePlannerApi, () => [["login", lambda_type(LoginRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["register", lambda_type(RegisterRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["me", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getEvents", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Event$_$reflection())]))], ["getEvent", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createEvent", lambda_type(CreateEventRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateEvent", lambda_type(UpdateEventRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteEvent", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getGuests", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Guest_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Guest_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createGuest", lambda_type(CreateGuestRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Guest_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Guest_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateGuest", lambda_type(UpdateGuestRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Guest_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Guest_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteGuest", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["importGuests", lambda_type(tuple_type(string_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Guest_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Guest_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateGuestTags", lambda_type(UpdateGuestTagsRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Guest_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Guest_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["cloneGuestsFromEvent", lambda_type(CloneGuestsRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Guest_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Guest_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPairs", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(GuestPair_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(GuestPair_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createPair", lambda_type(CreatePairRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GuestPair_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", GuestPair_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deletePair", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getFamilies", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(tuple_type(Family_$reflection(), list_type(FamilyMember_$reflection()))), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(tuple_type(Family_$reflection(), list_type(FamilyMember_$reflection())))]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createFamily", lambda_type(CreateFamilyRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Family_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Family_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteFamily", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getGroups", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(tuple_type(GuestGroup_$reflection(), list_type(GroupMember_$reflection()))), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(tuple_type(GuestGroup_$reflection(), list_type(GroupMember_$reflection())))]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createGroup", lambda_type(CreateGroupRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GuestGroup_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", GuestGroup_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteGroup", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getTables", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Table_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Table_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createTable", lambda_type(CreateTableRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Table_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Table_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateTable", lambda_type(UpdateTableRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Table_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Table_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateTablePosition", lambda_type(UpdateTablePositionRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Table_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Table_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteTable", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getRules", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(SeatingRule_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(SeatingRule_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createRule", lambda_type(CreateRuleRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [SeatingRule_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", SeatingRule_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteRule", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getWeights", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Microsoft.FSharp.Collections.FSharpMap`2", [ConstraintKey_$reflection(), int32_type]), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [ConstraintKey_$reflection(), int32_type])]], [["ErrorValue", ApiError_$reflection()]]])]))], ["saveWeights", lambda_type(tuple_type(string_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [ConstraintKey_$reflection(), int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["arrange", lambda_type(ArrangeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ArrangeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ArrangeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["cancelArrange", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getArrangements", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Arrangement_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Arrangement_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getArrangement", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(Arrangement_$reflection(), list_type(SeatAssignment_$reflection())), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(Arrangement_$reflection(), list_type(SeatAssignment_$reflection()))]], [["ErrorValue", ApiError_$reflection()]]])]))], ["selectArrangement", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["lockSeat", lambda_type(LockSeatRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["unlockSeat", lambda_type(tuple_type(string_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["likeArrangement", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["unlikeArrangement", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["setArrangementNotes", lambda_type(tuple_type(string_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["rateArrangement", lambda_type(RateArrangementRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ArrangementFeedback_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ArrangementFeedback_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getArrangementFeedback", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ArrangementFeedback_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(ArrangementFeedback_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateProfile", lambda_type(UpdateProfileRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changePassword", lambda_type(ChangePasswordRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteAccount", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getConnectedProviders", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(tuple_type(string_type, string_type))]))], ["hasPassword", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [bool_type]))], ["getTags", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Tag_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Tag_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createTag", lambda_type(CreateTagRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Tag_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Tag_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateTag", lambda_type(UpdateTagRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Tag_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Tag_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deleteTag", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getTagGroupStrategies", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(TagGroupStrategyEntry_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(TagGroupStrategyEntry_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["saveTagGroupStrategies", lambda_type(SaveTagGroupStrategiesRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getRsvpConfig", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(RsvpConfig_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(RsvpConfig_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["saveRsvpConfig", lambda_type(SaveRsvpConfigRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [RsvpConfig_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", RsvpConfig_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getRsvpSummary", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [RsvpSummary_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", RsvpSummary_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getRsvpGuestLinks", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(RsvpGuestLink_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(RsvpGuestLink_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["generateRsvpTokens", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(RsvpGuestLink_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(RsvpGuestLink_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPublicLinks", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PublicLink_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(PublicLink_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createPublicLink", lambda_type(CreatePublicLinkRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PublicLink_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PublicLink_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updatePublicLink", lambda_type(UpdatePublicLinkRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PublicLink_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PublicLink_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["deletePublicLink", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getAuthMode", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [bool_type]))], ["getDebugUsers", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(User_$reflection())]))], ["debugLogin", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))]]);
}

